import React from 'react';
import bem from 'utils/bem';
import FixedHeader from '../FixedHeader';
import StaticHeader from '../StaticHeader';

import './index.sass';

const { block } = bem('front-header');

const FrontHeader = ({ menu }) => {
    return (
        <div className={block()}>
            <StaticHeader menu={menu}/>
            <FixedHeader menu={menu} />
        </div>
    )
}

export default FrontHeader;
